import axios from 'axios';

export default ({ order, resolve, reject }) => {
    axios.get(`/registerPayment/${order}`)
        .then(({ data }) => {
            if(data.success) {
                resolve(data)
            } else {
                reject(data)
            }

        })
        .catch(e => {
            reject(e)
        })
}

